import { useMutation } from "@tanstack/react-query";

import { useAuthentication } from "@app/store/useAuthtentication";

import { reassignToken } from "./reassignToken";
import { IReassignTokenPayload } from "./types";

export const useReassignToken = () => {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  const mutation = useMutation({
    mutationFn: async (payload: IReassignTokenPayload) => {
      const response = await reassignToken(payload, token ?? "");
      return response;
    }
  });

  return mutation;
};
